// Angular
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store/index';

// Service
import { SoledadUserService } from './user.service';
import { SoledadAuthenticationService } from '../b2b/auth.service';
import { SalesforceService } from '../utils/salesforce.service';

// Models
import { Cart } from '../../models/b2b/cart';
import { User, UserHelper } from '../../models/b2b/user';

// Utils
import { Base64 } from '../../lib/helpers/utils';

// Moment
import * as moment from 'moment';
import { Product } from 'app/shared/models/b2b/product';
import { Md5 } from 'ts-md5';

declare var connectif: any;
declare var connectifConfiguration: any;
declare var initializeConnectif: any;

@Injectable()
export class ConnectifService {
    store: AppState = null;
    customerId: string;
    host = window.location;
    uuid = localStorage.getItem('uuid');

    lastConnectifObjectSent: string = '';
    lastTimeConnectifObjectSent: number = 0;
    lastConnectifPageUrl: string = '';

    constructor(
        private store$: Store<AppState>,
        private soledadUserService: SoledadUserService,
        private authService: SoledadAuthenticationService,
        private salesforceService: SalesforceService
    ) {
        this.setUuid();

        this.store$
            .select((state) => state)
            .subscribe((store) => {
                this.store = store;
            });
    }

    setUuid() {
        this.uuid = localStorage.getItem('uuid');
        if (!this.uuid) {
            setTimeout(() => {
                this.setUuid();
            }, 500);
        }
    }

    sendSearchEvent(search: any, user: User): void {
        if (user && user.tipoUsuario && this.isComercial(user.tipoUsuario)) {
            return;
        }

        if (typeof connectif !== 'undefined') {
            connectif.managed.sendEvents([{ type: 'search', searchText: search }], {});
        } else {
            setTimeout(() => {
                this.sendSearchEvent(search, user);
            }, 1000);
        }
    }

    syncAllEvents(user: User): void {
        if (user && user.tipoUsuario && this.isComercial(user.tipoUsuario)) {
            return;
        }

        if (typeof connectif !== 'undefined') {
            this.cleanConnectifContainer();
            connectif.managed.getAllEventsAsync().then(function onAllEvents(events) {
                connectif.managed.sendEvents(events);
            });
        } else {
            setTimeout(() => {
                this.syncAllEvents(user);
            }, 1000);
        }
    }

    sendSpecialPageVisit(type) {
        this.sendEvent([{ type: type }]);
    }

    sendLoginEventUser(user: User): void {
        const ttype = [{ type: 'login' }];
        const entityInfo = this.getUserEntity(user);
        const entities = {
            entityInfo
        };

        if (user && user.tipoUsuario && this.isComercial(user.tipoUsuario)) {
            return;
        }

        if (typeof connectif !== 'undefined') {
            this.cleanConnectifContainer();
            connectif.managed.getAllEventsAsync().then(function onAllEvents(events) {
                connectif.managed.sendEvents(ttype, entities);
            });
            this.salesforceService.sendUserIdentity(user);
        } else {
            setTimeout(() => {
                this.sendLoginEventUser(user);
            }, 1000);
        }
    }

    cleanConnectifContainer() {
        // let a = document.getElementById('connectiff-inline');
        // if (a) {
        //     a.innerHTML = '';
        // }
    }

    sendEvent(type: any = [], obj: any = {}): void {
        const ttype = type;

        if (typeof connectif !== 'undefined') {
            this.cleanConnectifContainer();
            connectif.managed.getAllEventsAsync().then((events) => {
                let newType = ttype.concat(events);

                const currentTime = new Date().getTime();
                const currentObjHash = Md5.hashStr(JSON.stringify(obj));
                const timeDiff = currentTime - this.lastTimeConnectifObjectSent;

                if (
                    !this.lastConnectifObjectSent ||
                    currentObjHash !== this.lastConnectifObjectSent ||
                    document.location.href !== this.lastConnectifPageUrl ||
                    timeDiff >= 4000
                ) {
                    connectif.managed.sendEvents(newType, obj);
                    this.lastConnectifObjectSent = currentObjHash;
                    this.lastTimeConnectifObjectSent = currentTime;
                    this.lastConnectifPageUrl = document.location.href;
                }
            });
        } else {
            setTimeout(() => {
                this.sendEvent(ttype, obj);
            }, 1000);
        }
    }

    purchase(user: User, checkout: any): void {
        const cartId = this.uuid;
        const entityInfo = this.getUserEntity(user);
        const cartItems = this.extractItemsFromCheckoutItems(checkout.cart);

        const purchase = {
            cartId: cartId,
            totalQuantity: checkout.cart.numItems,
            totalPrice: this.rround(checkout.importeTotal),
            products: this.extractItemsFromCartItems(cartItems),
            purchaseId: 'purhase-' + cartId,
            purchaseDate: moment().format()
        };

        // const pageVisit = [ {'type': 'purchase', purchase}, {'type': 'page-visit'} ];
        const pageVisit = [{ type: 'purchase', purchase }];
        const entities = {
            entityInfo
        };

        // console.log('checkout', checkout);
        // console.log('pageVisit', pageVisit);
        // console.log('entities', entities);

        if (user && user.tipoUsuario && this.isComercial(user.tipoUsuario)) {
            return;
        }

        this.sendEvent(pageVisit, entities);
        this.salesforceService.trackPurchase('purhase-' + cartId, this.rround(checkout.importeTotal), cartItems);
        this.resetUuid();
    }

    viewProduct(user: User, shopCart: Cart, cartItems, product: Product) {
        if (user && user.tipoUsuario && this.isComercial(user.tipoUsuario)) {
            return;
        }
        const entityInfo = this.getUserEntity(user);
        const products = this.extractItemsFromCartItems(cartItems);
        const cart = {
            cartId: this.uuid,
            totalQuantity: shopCart.numItems,
            totalPrice: this.rround(shopCart.totalMostrar),
            products
        };
        const entities = {
            entityInfo,
            cart
        };

        const pageVisit = [
            {
                type: 'product-visited',
                product: this.getProductEntity(product)
            }
        ];
        if (typeof connectif !== 'undefined') {
            connectif.managed.sendEvents(pageVisit, entities);
            this.salesforceService.trackViewProduct(product);
            this.salesforceService.trackCart(this.uuid, this.rround(shopCart.totalMostrar), cartItems);
        } else {
            setTimeout(() => {
                this.viewProduct(user, shopCart, cartItems, product);
            }, 1000);
        }
    }

    pageVisit(user: User, shopCart: Cart, cartItems) {
        const entityInfo = this.getUserEntity(user);
        const products = this.extractItemsFromCartItems(cartItems);
        const cart = {
            cartId: this.uuid,
            totalQuantity: shopCart.numItems,
            totalPrice: this.rround(shopCart.totalMostrar),
            products
        };

        // const pageVisit = [ {'type': 'page-visit'} ];
        const pageVisit = [];
        const entities = {
            entityInfo,
            cart
        };

        if (user && user.tipoUsuario && this.isComercial(user.tipoUsuario)) {
            return;
        }

        this.sendEvent(pageVisit, entities);
        this.salesforceService.trackCart(this.uuid, this.rround(shopCart.totalMostrar), cartItems);
    }

    private rround(value) {
        return Math.round((value + Number.EPSILON) * 100) / 100;
    }

    private extractItemsFromCheckoutItems(cart) {
        const ids = cart.items.ids;
        const items = [];

        ids.map(function (item, index) {
            const linea = cart.items.entities[item];
            if (linea) {
                items.push(linea);
            }
        });

        return items;
    }

    private extractItemsFromCartItems(items) {
        let products = [];
        items.map((item, index) => {
            products.push({
                quantity: item.quantity,
                price: this.rround(item.quantity * item.product.rates.base.precioMostrarBusqueda),
                productDetailUrl: this.host.origin + '/dashboard/products/main/' + item.product_id,
                productId: item.product_id,
                name: item.product.info.nombre.trim(),
                imageUrl: item.product.info.imagenarticulobig,
                unitPrice: this.rround(item.product.rates.base.precioMostrarBusqueda),
                availability: 'InStock',
                categories: [item.product.info.tipo],
                brand: item.product.info.marca.trim(),
                thumbnailUrl: item.product.info.imagenarticulo
            });
        });

        return products;
    }

    private getUserPromos(): string {
        const userpromos = sessionStorage.getItem('userpromos') || '';
        return Base64.decode(userpromos);
    }

    private getValidUserEmail(userEmail: string, userCode: string): string {
        let ret = userCode + '@gsoledad.com';
        let trimedEmail = (userEmail + '').trim();

        if (trimedEmail !== '') {
            if (trimedEmail.indexOf(';') >= 0) {
                const parts = trimedEmail.split(';');
                ret = parts.shift();
            } else if (trimedEmail.indexOf(',') >= 0) {
                const parts = trimedEmail.split(',');
                ret = parts.shift();
            } else {
                ret = trimedEmail;
            }
        }

        return ret;
    }

    private isValidESMobile(mobile: string): boolean {
        return mobile.charAt(0) === '6' || mobile.charAt(0) === '7';
    }

    private isValidPTMobile(mobile: string): boolean {
        return mobile.charAt(0) === '9';
    }

    private isValidFRMobile(mobile: string): boolean {
        return true;
    }

    private getValidUserMobile(userMobile: number, market: string): string {
        let ret = userMobile + '';

        if (market === 'es' && !this.isValidESMobile(ret)) {
            ret = '';
        }

        if (market === 'pt' && !this.isValidPTMobile(ret)) {
            ret = '';
        }

        if (market === 'fr' && !this.isValidFRMobile(ret)) {
            ret = '';
        }

        return ret;
    }

    private getProductEntity(product: Product) {
        let ret = {
            name: product.info.nombre.trim(),
            productDetailUrl: this.host.origin + '/dashboard/products/main/' + product.info.codigo,
            productId: product.info.codigo,
            unitPrice: this.rround(product.rates.base.precioMostrarBusqueda),
            availability: 'InStock',
            imageUrl: product.info.imagenarticulobig,
            description: '',
            categories: [product.info.tipo],
            brand: product.info.marca.trim(),
            thumbnailUrl: product.info.imagenarticulo
        };
        return ret;
    }

    private getUserEntity(user: User) {
        const validEmail = this.getValidUserEmail(user.connectif_email, user.clienteCodigo);
        const validMobilePhone = this.getValidUserMobile(user.connectif_movil, user.mercado);
        const suscriptionStatus = user.connectif_suscripcion ? 'subscribed' : 'none';
        const cleanName = user.clienteNombre.trim();
        const promos = this.getUserPromos();
        const defaultUserAddress = UserHelper.getUserDefaultAddress(user);

        let ret = {
            primaryKey: validEmail,
            _name: cleanName,
            _surname: '-',
            _newsletter_subscription_status: suscriptionStatus,
            _newsletterSubscriptionStatus: suscriptionStatus,
            _mobilePhone: validMobilePhone,
            email_soledad: validEmail,
            agente: user.connectif_agente,
            cadena: user.connectif_cadena,
            codigo_as400: user.connectif_as400,
            empresa: user.connectif_empresa,
            movil: validMobilePhone,
            provincia: user.connectif_provincia,
            zona: user.connectif_zona,
            promotions: promos
        };

        if (defaultUserAddress && defaultUserAddress.agente2 !== '') {
            ret['agente2'] = defaultUserAddress.agente2;
        }

        return ret;
    }

    private resetUuid() {
        localStorage.removeItem('uuid');
        this.authService.regenerateUuidToken();

        setTimeout(() => {
            this.uuid = localStorage.getItem('uuid');
        }, 1000);
    }

    private isComercial(tipo: string): boolean {
        return tipo === 'COMERCIAL';
    }
}
